import React from 'react';

function Footer() {
    return (
        <footer className="footer-container">
            <span>© {new Date().getFullYear()} - Halfwish</span>
        </footer>
    );
}

export default Footer;
